<template>
  <div :class="headerColor">
    <b-navbar
      :class="[
        expandeds
          ? `navbar-show navbron navbar-header`
          : 'navbar-header nav-black'
      ]"
      toggleable="lg"
      :fixed="fixed"
    >
      <b-navbar-brand to="/" style="margin:5px 0px;" class="header-logo">
        <img src="@/assets/img/person/icon.png" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" @click="navBarClick">
        <template v-slot:default="{ expanded }">
          <!-- <b-icon
            style="margin-bottm:0px !important"
            v-if="expanded"
            icon="x"
            class="h3 expand-icon"
          ></b-icon>
          <b-icon
            style="color:#fff;margin-bottm:0px !important"
            v-else
            icon="list"
            class="h3 expand-icon"
          ></b-icon>-->
          <img
            class="expand-icon"
            v-if="expanded"
            src="../assets/img/home/ons.png"
            alt
          />
          <img
            class="expand-icons"
            v-else
            src="../assets/img/home/closes.png"
            alt
          />
        </template>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto dropcolor" @click="AllClick">
          <b-nav-item
            :class="[active == 'home' ? 'active' : '']"
            to="/"
            @click="
              () => {
                ActiveClick('home');
                navBarHide();
              }
            "
            >首页</b-nav-item
          >

          <b-nav-item
            v-if="!hasPhone"
            :class="[active == 'product' ? 'active' : '']"
            @click="
              () => {
                ActiveClick('product');
                navBar();
              }
            "
            >项目机会</b-nav-item
          >
          <!-- <b-nav-item
            v-if="showSolution"
            :class="[active == 'solution' ? 'active' : '']"
            to="/solution"
            @click="ActiveClick('solution')"
            >解决方案</b-nav-item
          >-->
          <b-nav-item-dropdown v-if="hasPhone" text="项目机会" right>
            <b-dropdown-item
              v-for="(item, index) in projectCategories"
              :class="[phoneActive == item.id ? 'active' : '']"
              :key="index"
              @click="ToRouter('/product', item.id)"
              >{{ item.name }}</b-dropdown-item
            >
          </b-nav-item-dropdown>

          <b-nav-item
            :class="[active == 'new' ? 'active' : '']"
            to="/new"
            @click="
              () => {
                ActiveClick('new');
                navBarHide();
              }
            "
            >新闻资讯</b-nav-item
          >
          <b-nav-item
            :class="[active == 'about' ? 'active' : '']"
            to="/about"
            @click="
              () => {
                ActiveClick('about');
                navBarHide();
              }
            "
            >关于我们</b-nav-item
          >
        </b-navbar-nav>
        <b-nav-form class="header-login">
          <b-button
            v-if="!login"
            variant="primary"
            class="my-2 my-sm-0"
            to="/login"
            >登录/注册</b-button
          >
          <a-dropdown v-model="visible" class="login-user-info" v-if="login">
            <a @click="e => e.preventDefault()">
              <img v-if="user.avatar" :src="getImgUrl(user.avatar)" />
              <a-avatar v-else :size="46" icon="user" />
              <p>{{ user.nickname }}</p>
            </a>
            <a-menu slot="overlay" @click="menuHandler">
              <a-menu-item key="1">
                个人中心
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="2">
                退出登录
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </b-nav-form>
      </b-collapse>
    </b-navbar>
    <b-container
      :class="headerColor"
      class="navbar-link-tab container-nopad"
      fluid
      v-if="navbarShow"
    >
      <ul class="navbar-link">
        <li
          v-for="(item, index) in projectCategories"
          :class="[phoneActive == item.id ? 'active' : '']"
          :key="index"
          @click="ToRouter('/product', item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
    </b-container>
  </div>
</template>
<script>
import Api from "@/apis";
import publicChange from "@/assets/js/index.js";
export default {
  name: "Header",
  data() {
    return {
      login: false,
      visible: false,
      user: {},
      expandeds: false,
      fixed: "false",
      i: 0,
      hasPhone: false,
      navbarShow: false,
      projectCategories: [],
      navItem: [
        {
          title: "尽职调查咨询",
          to: "project/diligence",
          id: "diligence"
        },
        {
          title: "IT审计和咨询",
          to: "project/it",
          id: "digital"
        },
        {
          title: "数字化转型咨询",
          to: "project/digital",
          id: "digital"
        }
      ]
    };
  },
  props: {
    headerColor: {
      type: String,
      default: "nav-header-white"
    },
    detail: {
      type: Boolean,
      default: true
    },
    ActiveClick: {
      type: Function
    },
    active: {
      type: String
    },
    phoneActive: {
      type: String
    }
  },
  mounted() {
    this.User();
    this.getProjectCategories();
    window.addEventListener("scroll", this.handleScroll, true);
    if (this._isMobile()) {
      this.hasPhone = true;
    } else {
      this.hasPhone = false;
    }
    // 监听（绑定）滚轮 滚动事件
  },

  methods: {
    async getProjectCategories() {
      try {
        const query = {
          current: 1,
          filters: {
            flagRecommend: 1
          }
        };
        const data = await Api.Project.getProjectCategories(query);
        const cateData = data.data;
        this.projectCategories = cateData;
      } catch (e) {
        this.$message.error(e);
      }
    },
    AllClick() {
      this.expandeds = false;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    navBarClick() {
      this.expandeds = !this.expandeds;
    },
    handleScroll() {
      // 页面滚动距顶部距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scroll = scrollTop - this.i;
      this.i = scrollTop;
      if (scroll < 0) {
        if (this.hasPhone) {
          this.fixed = "top";
        } else {
          this.fixed = "false";
        }
      } else {
        this.fixed = "false";
      }
    },
    menuHandler(e) {
      this.visible = false;
      if (e.key == "1") {
        this.ToRouter("/user/setting");
      } else if (e.key == "2") {
        localStorage.removeItem("token");
        this.$router.push("/");
        this.$router.go(0);
      }
    },
    ToRouter(path, id) {
      if (id) {
        this.$router.push({
          path: path,
          query: {
            id: id
          }
        });
        this.navbarShow = false;
      } else {
        this.$router.push(path);
        this.navbarShow = false;
      }
    },
    navBar() {
      this.navbarShow = !this.navbarShow;
    },
    navBarHide() {
      this.navbarShow = false;
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },

    //当前登录用户
    async User() {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        if (token && token.accessToken) {
          const data = await Api.User.getUser();
          if (data) {
            this.user = data;
            this.login = true;
          }
        } else {
          this.user = {};
          this.login = false;
        }
      } catch (e) {
        this.$message.error(e);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar {
  padding: 0rem;
  z-index: 999;
}

.nav-item {
  text-align: center;
}
</style>
